<template>
  <div class="page">
    <top-banner :img-url="headPicUrl" :pageTitle="title"></top-banner>
    <div class="container">
      <section-title
        :title="$i18n.t('about.全球布局')"
        v-if="category == '全球'"
      ></section-title>
      <section-title :title="$i18n.t('about.中国布局')" v-else></section-title>
      <div class="desc-list">
        <div class="desc row" v-for="(item, index) in desclist" :key="index">
          <!--图标-->
          <div
            class="icon"
            :style="{ 'background-image': 'url(' + item.picture + ')' }"
          ></div>
          <!--详情-->
          <div>
            <div class="info row">
              <div class="num" >
                <span>{{ item.num }}</span>
                <span style="font-size: 24px;vertical-align: text-top;">{{item.suffix}}</span>
                <span
                  style="font-size: 16px;vertical-align: text-bottom;margin-left: -10px;"
                  >{{ item.uint }}</span
                >
              </div>
              <!-- <div class="num" >
                <span>{{ item.num }}</span>
                <span style="font-size: 16px;vertical-align: text-bottom;">{{
                  item.unit
                }}</span>
              </div> -->
            </div>
            <div class="text" v-html="item.title"></div>
          </div>
        </div>
      </div>
    </div>
    <!--全球分布地图-->
    <div :class="[category == '中国' ? 'zh' : '', 'distribution']">
      <!--切换全球和中国-->
      <div class="container">
        <div class="row btns">
          <div
            :class="[category == '全球' ? 'active' : '', 'btn']"
            @click="handleChangeCategory('全球')"
          >
            {{ $i18n.t("about.全球") }}
          </div>
          <div
            :class="[category == '中国' ? 'active' : '', 'btn']"
            @click="handleChangeCategory('中国')"
          >
            {{ $i18n.t("about.中国") }}
          </div>
        </div>
      </div>
      <div
        v-for="(item, index) in markerlist"
        :key="index"
        :style="{
          position: 'absolute',
          left: (item.x * 100) / 1920 + 'vw',
          bottom: (item.y * 100) / 1920 + 'vw',
        }"
      >
        <div
          :class="[index == markerindex ? 'active' : '', 'marker']"
          @mouseenter="markerindex = index"
        ></div>
        <div class="label" v-if="index == markerindex">
          <pre class="title">{{ item.title }}</pre>
        </div>
      </div>
    </div>

    <!--企业列表-->
    <div class="container enterprise-list" :style="{display:category === '中国'?'block':'flex'}">
      <!-- <div class="enterpriselist" v-if="btntype===0">
                <div v-for="(item,index) in enterpriselist" :key="index">
                    <div class="title">{{item.title}}</div>
                    <div v-for="(enterpriseitem,enterpriseindex) in item.list" :key="enterpriseindex" class="list">
                        {{enterpriseitem}}
                    </div>
                </div>
            </div> -->
      <div
        v-for="(item, index) in enterpriselist"
        :key="index"
        :class="category === '中国' ? 'enterprise-china' : 'enterpriselist'"
      >
        <div class="title">{{ item.area }}</div>
       <div>
          <div
          v-for="(enterpriseitem, enterpriseindex) in item.rows"
          :key="enterpriseindex"
          class="list"
        >
          {{ enterpriseitem.name }}
        </div>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
var TWEEN = require("@tweenjs/tween.js");
export default {
  data() {
    return {
      title: "",
      headPicUrl: "",
      category: "全球",

      num: 0,
      numTween: 0,
      desclist: [],
      btntype: 0,
      markerindex: "100",
      markerlist: [
        // [
        //   {
        //     x: "228",
        //     y: "567",
        //     title: this.$i18n.t("about.markerTitle[0]"),
        //   },
        //   {
        //     x: "284",
        //     y: "549",
        //     title: this.$i18n.t("about.markerTitle[1]"),
        //   },
        //   {
        //     x: "314",
        //     y: "552",
        //     title: this.$i18n.t("about.markerTitle[2]"),
        //   },
        //   {
        //     x: "386",
        //     y: "509",
        //     title: this.$i18n.t("about.markerTitle[3]"),
        //   },
        //   {
        //     x: "718",
        //     y: "384",
        //     title: this.$i18n.t("about.markerTitle[4]"),
        //   },
        //   {
        //     x: "720",
        //     y: "320",
        //     title: this.$i18n.t("about.markerTitle[5]"),
        //   },
        //   {
        //     x: "790",
        //     y: "289",
        //     title: this.$i18n.t("about.markerTitle[6]"),
        //   },
        //   {
        //     x: "811",
        //     y: "366",
        //     title: this.$i18n.t("about.markerTitle[7]"),
        //   },
        //   {
        //     x: "1340",
        //     y: "433",
        //     title: this.$i18n.t("about.markerTitle[8]"),
        //   },
        //   {
        //     x: "1377",
        //     y: "586",
        //     title: this.$i18n.t("about.markerTitle[9]"),
        //   },
        //   {
        //     x: "1415",
        //     y: "585",
        //     title: this.$i18n.t("about.markerTitle[10]"),
        //   },
        //   {
        //     x: "788",
        //     y: "424",
        //     title: this.$i18n.t("about.markerTitle[11]"),
        //   },
        // ],
        // this.$i18n.t("about.markerTitles"),
      ],
      enterpriselist: [],
      numberList: [],
    };
  },
  watch: {
    num() {
      var that = this;
      //将数字的初始值都变成0
      that.desclist = that.desclist.map((x) => {
        x.num = 0;
        return x;
      });
      if (that.desclist.length) {
        //依次逐渐增加到目的值，动画依次开始，同时结束
        for (var i = 0; i < 4; i++) {
          (function(index) {
            setTimeout(function() {
              var newNumber = that.numberList;
              new TWEEN.Tween({
                number: 0,
              })
                .to(
                  {
                    number: newNumber[index],
                  },
                  3000 - index * 500
                )
                .onUpdate((tween) => {
                  that.desclist[index].num = tween.number.toFixed(0);
                })
                .start();

              function animate() {
                if (TWEEN.update()) {
                  requestAnimationFrame(animate);
                }
              }
              animate();
            }, index * 500);
          })(i);
        }
      }
    },
  },
  activated() {
    this.num = this.num + 1;
  },
  created() {
    this.getData();
  },
  methods: {
    handleChangeCategory(type) {
      this.category = type;

      this.getData();
    },
    getData() {
      this.$api.about
        .getGlobalData({
          category: this.category,
        })
        .then((res) => {
          this.enterpriselist = res.globalCompanys;
          this.title = res.title;
          this.headPicUrl = this.$imgHost + res.headPicUrl;
          const list = [];
          res.globalCompanys.forEach((item) => {
            item.rows.forEach((i) => {
              list.push({
                x: i.xcoor,
                y: i.ycoor,
                title: i.name,
              });
            });
          });
          this.markerlist = list;
          this.markerindex = 100;
          this.num = this.num + 1;
          this.numberList = [
            res.global.position1num,
            res.global.position2num,
            res.global.position3num,
            res.global.position4num,
          ];
          this.desclist = [
            {
              num: 0,
              uint: res.global.position1uint,
              title: res.global.position1title,
              picture: this.$imgHost + res.global.position1iconUrl,
              suffix:res.global.position1suffix,
            },
            {
              num: 0,
              uint: res.global.position2uint,
              title: res.global.position2title,
              picture: this.$imgHost + res.global.position2iconUrl,
               suffix:res.global.position2suffix,
            },
            {
              num: 0,
              uint: res.global.position3uint,
              title: res.global.position3title,
              picture: this.$imgHost + res.global.position3iconUrl,
               suffix:res.global.position3suffix,
            },
            {
              num: 0,
              uint: res.global.position4uint,
              title: res.global.position4title,
              picture: this.$imgHost + res.global.position4iconUrl,
               suffix:res.global.position4suffix,
            },
          ];
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.desc-list {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}
.column {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.desc {
  text-align: center;
  $color: rgba(28, 170, 255, 1);
  margin-bottom: 80px;
  /*height: 100px;*/

  .icon {
    height: 77px;
    width: 94px;
    margin-right: 10px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .info {
    color: $color;
    justify-content: center;
    margin: auto;
    .num {
      font-size: 60px;
      font-weight: 500;
    }
  }

  &:nth-child(1) {
    .info {
      width: 145px;
    }
  }
  &:nth-child(2) {
    .info {
      width: 90px;
    }
  }
  &:nth-child(3) {
    .info {
      width: 190px;
    }
  }
  &:nth-child(4) {
    .info {
      width: 108px;
    }
  }

  .unit {
    width: 170px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #1caaff;
    position: relative;
    top: -42px;
  }

  .text {
    font-size: $font-size-large;
    color: $subtitle-color;
  }
}

/*全球分布地图*/
.distribution {
  width: 100vw;
  height: 53.23vw;
  background: url("../../assets/img/about/distribution.png");
  background-size: cover;
  background-position: center;
  position: relative;

  .marker {
    background: url("../../assets/icon/marker.svg");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: vw(26);
    height: vw(36);
    position: absolute;
    left: vw(2);
    bottom: vw(-1);
  }

  .active {
    width: vw(41);
    height: vw(56);
    transition: all 0.3s ease;
    position: absolute;
    left: vw(-5);
  }

  .label {
    margin-left: 67px;
    margin-bottom: 17px;

    .title {
      display: inline-block;
      font-size: 14px;
      min-height: 49px;
      min-width: 120px;
      padding: 9px 20px;
      background: #d5d0ce;
      line-height: 31px;
      border-radius: 8px 8px 8px 0;
      position: relative;
      z-index: 100;
    }

    .title:before {
      content: "";
      position: absolute;
      right: 100%;
      bottom: 0px;
      border-top: 5px solid transparent;
      border-right: 7px solid #d5d0ce;
      border-bottom: 5px solid #d5d0ce;
      border-left: 7px solid transparent;
    }
  }
}

.zh {
  background: url("../../assets/img/about/zh.jpg");
  background-size: cover;
  background-position: center;
}

.btns {
  float: right;
  margin-top: 63px;
  border: 1px solid $primary-color;
  background: #fff;
  color: #707070;
  width: 164px;

  .btn {
    width: 86px;
    height: 36px;
    line-height: 36px;
    font-size: $font-size-base;
    text-align: center;
    cursor: pointer;
  }

  .active {
    background: $primary-color;
    color: #ffffff;
    position: relative;
    left: 0;
  }
}

.enterpriselist {
  flex: 1;
  // display: flex;
  // flex-direction: row;
  // justify-content: space-between;
}

.enterprise-list {

  // display: flex;
  align-items: flex-start;
  padding: 46px 0;

  .title {
    font-size: $font-size-large;
    color: $subtitle-color;
    font-weight: 500;
    margin-bottom: 34px;
  }

  .list {
    font-size: $font-size-small;
    font-weight: 500;
    line-height: 35px;
    color: $text-color;
  }

  .enterprise-china {
    margin-bottom: 30px;

    .title {
      margin-bottom: 15px;
    }

    .list {
      vertical-align: text-top;
      width: 33.3333%;
      display: inline-block;
    }
  }
}
</style>
